import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  toolbar: {
    height: 70,
  },
  barTitle: {
    width: '100%',
  },
  title: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '80%',
    maxWidth: 1000,
    margin: '0 auto',
  },

  buttonContainer: {
    paddingTop: theme.spacing(2),
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    color: theme.colors.white,
    marginRight: theme.spacing(1),
    backgroundColor: theme.colors.darkBlue,
  },
  checklistHeader: {
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
    marginTop: theme.spacing(2),
  }
}));

export default useStyles;
